// extracted by mini-css-extract-plugin
export default {"company":"ResaleParticipantDetails_company__2uFea","reporter":"ResaleParticipantDetails_reporter__LgzV0"};